import moment from "moment";
import {
    getScripFromInstandExchange, companyBackgroundData, boardOfDirectorData, companyHistory,
    companyListingInformation, companyExchangeData
} from "../../apis";
import { movingAverage, scripOverviewDelivery } from "../../apis/cds";
import { scripoverviewMarketPulse, securityDetails, scripoverviewMarketMovement, contractDetails, gsmGradeCategory } from "../../apis/nontransactional";
import {
    getMktSegIdFromApiExchangeName, getMktSegIdFromMappedMktSegId, getAssetExchangeNameFromMktSegId,
    getMappedMktSegIdFromApiExchangeName, getTradeTimeForValue, convertToDate, getDynamicParamsForToFixed,
    getDecimalLocatorFromApiExchangeName, getApiExchangeNameFromMktSegId, convertScripResponseWatchlistGrid
} from "../../utils/global_functions";
import { SPECIAL_PREOPEN, CALL_AUCTION, BUSINESS_LAYER_RESPONSE, EXCHANGE_NAME_API } from "../../utils/global_variables";
import { _getScripsInfo } from "../watchlist";

async function _getFutureTabData(arrWhatsHotData, objPayload) {
    try {
        const objResp = await getScripFromInstandExchange(objPayload);
        //Vaibhav Singh: BT-116978 : Fixed Decimal locator functions
        const arrFutureTabData = await objResp?.data?.result?.hits?.hits?.map((item) => item?._source).map((item) => ({ ...item, nAssetMktId: getMktSegIdFromApiExchangeName(getAssetExchangeNameFromMktSegId(getMktSegIdFromMappedMktSegId(item.nMarketSegmentId))), nMktIDForDontmiss: getMappedMktSegIdFromApiExchangeName(item.ExchangeSegment), decimalLocatorLength: getDynamicParamsForToFixed(item.ExchangeSegment), DecimalLocator: getDecimalLocatorFromApiExchangeName(item?.ExchangeSegment), expiry: moment(item?.nExpiryDate1)?.format('D MMM\'YY')?.toUpperCase() }));
        const arrFutureDataWithotSpread = arrFutureTabData?.filter((item) => item.nSpread === 0);
        const hotList = new Map();
        // Create a object of hotList data and Map with keys don't miss bug done by Azeem
        arrWhatsHotData?.forEach(({ mktid, token, class: class1, class2, event, date, Desc }) => {
            if (hotList.has(`${mktid}_${token}`)) {
                const arrHotList = hotList.get(`${mktid}_${token}`);
                arrHotList.push({ color: class1, bg_color: class2, event, date, Desc });
                hotList.set(`${mktid}_${token}`, arrHotList);
            } else {
                hotList.set(`${mktid}_${token}`, [{ color: class1, bg_color: class2, event, date, Desc }]);
            }
        });
        for (let i = 0; i < arrFutureDataWithotSpread?.length; i++) {
            if (hotList?.has(arrFutureDataWithotSpread[i]?.nMktIDForDontmiss + '_' + arrFutureDataWithotSpread[i]?.nToken)) {
                arrFutureDataWithotSpread[i].dontMiss = hotList?.get(arrFutureDataWithotSpread[i]?.nMktIDForDontmiss + '_' + arrFutureDataWithotSpread[i]?.nToken);
            } else {
                arrFutureDataWithotSpread[i].dontMiss = [];
            }
        }
        return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: arrFutureDataWithotSpread };

    } catch (error) {
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, data: null };
    }
}


async function _getCompanyBackground(objPayload) {

    //This function will display the company address details in scripover => company info tab
    //objPayload contains Token number and Exchange typeset


    try {
        let resp = await companyBackgroundData(objPayload);
        let companyBackground = resp?.data?.ResponseObject?.resultset[0];

        const objContact = {

            registrarName: companyBackground.RegistrarName,
            regAddress1: companyBackground.Reg_address_l,
            regAddress2: companyBackground.Reg_address_2,
            address1: companyBackground.Registr_address_1,
            address2: companyBackground.Registr_address_2,
            address3: companyBackground.Registr_address_3,
            address4: companyBackground.Registr_address_4,
            regCity: companyBackground.Reg_City,
            regPin: companyBackground.Reg_Pin,
            registrTell: companyBackground.Registr_tell,
            registrFax: companyBackground.Registr_Fax,
            registrEmail: companyBackground.Registr_Email,
            registrWebSite: companyBackground.Registr_WebSite,
            auditor: companyBackground.Auditor,
            hoa1: companyBackground.HO_address_1,
            hoa2: companyBackground.HO_address_2,
            hoa3: companyBackground.HO_address_3,
            hoc: companyBackground.HO_city,
            hop: companyBackground.HO_pin,
            hot: companyBackground.HO_tell,
            hof: companyBackground.HO_Fax,
            hoe: companyBackground.HO_Email,
            how: companyBackground.HO_Website

        };
        return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: objContact };
    } catch (error) {
        console.log("error", error);
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, error };
    }
}


async function _getSecurityDetails(objPayload) {
    // This function will display code details and security details in scripoverview => company info tab
    //objPayload contains segmentid number and token number
    try {
        const code = {
            "mktSegmentId": objPayload?.mktSegmentId,
            "siTemplateId": "DIET",
            "token": objPayload?.token
        };

        let resp = await securityDetails(code);
        const securityInfoDetails = resp?.data?.result?.secInfo[0];
        //Vaibhav Singh : BT-109089: Added Pivot Data in sceurityData for Support and resistance calculation 
        const securityData = {
            marketLot: securityInfoDetails?.nRegularLot,
            priceTick: securityInfoDetails?.nPriceTick,
            issuedCapital: securityInfoDetails?.nIssuedCapital,
            faceValue: securityInfoDetails?.nFaceValue,
            qtyFreeze: securityInfoDetails?.nFreezePercent,
            margin: securityInfoDetails?.nMarginMultiplier,
            exMultiplier: securityInfoDetails?.nIntrinsicValue,
            preOpen: securityInfoDetails?.nNormal_SecurityStatus,
            specialPreOpen: securityInfoDetails?.SPOS === SPECIAL_PREOPEN && securityInfoDetails?.SPOSTYPE === SPECIAL_PREOPEN ? 'Yes' : 'No',
            callAuction: securityInfoDetails?.nPriceQuotFactor === CALL_AUCTION.PRICEQUOTFACTOR || securityInfoDetails?.SPOSTYPE.toString().trim() === CALL_AUCTION.SPOSTYPE ? 'Yes' : 'No',
            pivot: resp?.data?.result?.pivot
        };

        const data = {
            code: securityInfoDetails?.InstrumentCode,
            instrument: securityInfoDetails?.nInstrumentType,
            isin: securityInfoDetails?.sISINCode
        };

        return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: { data, securityData, securityInfoDetails } };

    } catch (error) {
        console.log('error', error);
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, error };
    }

}


async function _getBoardOfDirectorsData(objPayload) {
    //This function will display the company director member details in scripover => company info tab
    //objPayload contains Token number and Exchange type
    try {
        const resp = await boardOfDirectorData(objPayload);
        //This function will display the company director member details in scripover => company info tab
        //objPayload contains Token number and Exchange type
        const boardOfDirector = resp.data.ResponseObject.resultset?.map((each, id) => ({
            directorName: each.DirectorName,
            qualification: each.Qualification,
            year: each.Year,
            remuneration: each.Remuneration,
            directorDesignation: each.DirectorDesignation
        }));
        return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: boardOfDirector };
    } catch (error) {
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, error };
    }
}

async function _getCompanyHistory(objPayload) {
    //This function will display the company history details in scripover => company info tab
    //objPayload contains Token number and Exchange type
    try {
        const resp = await companyHistory(objPayload);
        const companyInfo = resp.data.ResponseObject.resultset[0];
        const data = companyInfo?.memo;

        // Vinit R - 08-04-2024 Company Info to be kept common irrespective of exchanges -- Start
        if (!data) {
            throw new Error('Failed to get company history data');
        }
        // Vinit R - 08-04-2024 Company Info to be kept common irrespective of exchanges -- End

        return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data };
    } catch (error) {
        console.log("error", error);
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, error };
    }

}

async function _getCompanyExchangeData(objPayload) {
    //This function will display the company listed on details in scripover => company info tab
    //objPayload contains Token number and Exchange type
    try {
        const resp = await companyExchangeData(objPayload);
        //This function will display the company listed on details in scripover => company info tab
        //objPayload contains Token number and Exchange type
        const exchange = resp.data.ResponseObject.resultset;
        const data = exchange;

        // Vinit R - 08-04-2024 Company Info to be kept common irrespective of exchanges -- Start
        if (!data) {
            throw new Error('Failed to get company exchange data');
        }
        // Vinit R - 08-04-2024 Company Info to be kept common irrespective of exchanges -- End

        return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data };
    } catch (error) {
        console.log("error", error);
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, error };
    }
};






async function _getcompanyListingInformation(objPayload) {
    //This function will display the company listing details in scripover => company info tab
    //objPayload contains Token number and Exchange type
    try {

        const resp = await companyListingInformation(objPayload);
        //This function will display the company listing details in scripover => company info tab
        //objPayload contains Token number and Exchange type
        const companyListing = resp?.data?.ResponseObject.resultset.ListingInformationlist2.ListingInformation2;
        //Vaibhav Singh: 04-12-2023: BT-107248: Company Info Indices added : Start
        const partOfIndices = resp?.data?.ResponseObject?.resultset?.ListingInformationlist?.ListingInformation;
        const data = [{
            nseSymbol: companyListing.symbol,
            bseSymbol: companyListing.sc_code,
            bseGroup: companyListing.sc_group,
            isin: companyListing.isin,
            sector: companyListing.sect_name,
            partOfIndices: partOfIndices
        }];
        //Vaibhav Singh: 04-12-2023: BT-107248: Company Info Indices added : End
        return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data };
    } catch (error) {
        console.log("error", error);
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, error };
    }
}
async function _getMarketMovementInfo(objPayload) {
    //This function coonvert market movement response data in require format
    //objPayload ==>it contain market segmentid,token,time interval to detect change in  data of company
    //decimalLocator==>it should contain decimal locator of selected market movement script
    //decimalLocatorLength=>it should contain decimal locator length of selected market movement script
    const exchangeName = getApiExchangeNameFromMktSegId(getMktSegIdFromMappedMktSegId(objPayload?.MktSegId));
    const decimalLocator = getDecimalLocatorFromApiExchangeName(exchangeName);
    //BT-120319 : Scrip Overview – Market Movement : Bug Fixing : Manasa B : 23/10/2023 - Start
    // const decimalLocatorLength = getDynamicParamsForToFixed(exchangeName);

    try {
        let info = "";
        const resp = await scripoverviewMarketMovement(objPayload);
        const marketMovementInfo = resp?.data?.result[0];
        const result = marketMovementInfo?.map((ele) => {
            info = {

                Time: getTradeTimeForValue(ele.Time),
                nOpen: parseFloat((ele.nOpen / decimalLocator)),
                nHigh: parseFloat((ele.nHigh / decimalLocator)),
                nLow: parseFloat((ele.nLow / decimalLocator)),
                nClose: parseFloat((ele.nClose / decimalLocator)),
                nATP: parseFloat((ele.nATP / decimalLocator)),
                nTotalQtyTraded: parseFloat(ele.nTotalQtyTraded),
                // nTotalValueTraded: (ele.nTotalValueTraded / MULTIPLIER.LAKH).toFixed(decimalLocatorLength),
                nTotalValueTraded: (ele.nTotalValueTraded / decimalLocator).toFixed(2),
                nToken: ele.nToken,
                nMarketSegmentId: ele.nMarketSegmentId
                //BT-120319 : Scrip Overview – Market Movement : Bug Fixing : Manasa B : 23/10/2023 - End
            };
            return info;
        }
        );

        return { status: true, message: BUSINESS_LAYER_RESPONSE?.SUCCESS, data: result };


    } catch (error) {

        console.log(error);
        return { status: false, message: BUSINESS_LAYER_RESPONSE?.FAILURE, error };

    }

};




async function _getMarketPulse(objPayload) {
    //This function display market pulse card details in scripoverview => overview tab
    //objPayload contains mkt segment id and symbol

    try {
        const resp = await scripoverviewMarketPulse(objPayload);



        if (resp?.data?.result?.length) {
            // Vaibhav Singh:BT-109089: Market Pulse Data Called for getting scripinfo
            const payload = [];
            const marketPulseResp = resp?.data?.result?.map((ele) => {
                const obj = {};
                obj['nExpiryDate'] = ele?.nExpiryDate !== "0" ? convertToDate(ele?.nExpiryDate, "DDMMMYYYY") : '';
                obj['nStrikePrice'] = ele?.nStrikePrice !== -0.01 && ele?.nStrikePrice !== 0.00 && ele?.nStrikePrice !== 0.0000 ? ele?.nStrikePrice : '';
                obj['sOptionType'] = ele?.sOptionType.trim() !== "XX" ? ele?.sOptionType.trim() : "";
                obj['nLTP'] = ele?.nLTP === undefined ? 0.00 : ele?.nLTP;
                obj['nPercChange'] = ele?.nPercChange;
                obj['sDataDesc'] = ele?.sDataDesc;
                obj['nMarketSegmentId'] = ele?.nMarketSegmentId;
                obj['nToken'] = ele?.nToken;
                obj['sSymbol'] = ele?.sSymbol;
                payload.push({ mkt: EXCHANGE_NAME_API.NSE_DERV_API, token: ele?.nToken });
                return obj;
            });
            const resPonse = await _getScripsInfo(payload);
            const dataForMarketPulse = convertScripResponseWatchlistGrid(resPonse?.data?.objScripsResp?.result);

            return { status: true, message: BUSINESS_LAYER_RESPONSE?.SUCCESS, data: { marketPulseResp, dataForMarketPulse } };
        } else { }
    } catch (error) {
        console.log("error", error);
        return { status: false, message: BUSINESS_LAYER_RESPONSE?.FAILURE, error };
    }
}

async function _getContractDetails(objPayload) {
    //This function will display the company contract details in scripover => company informatiom
    //objPayload contains expire date, instrument name, mkt segment id ,option type, strike price, symbol and token number
    try {
        const code = {
            "expDate": objPayload?.expDate,
            "instName": objPayload?.instName,
            "mktSegmentId": objPayload?.mktSegmentId,
            "optType": objPayload?.optType,
            "siTemplateId": "DIET",
            "strkPrice": objPayload?.strkPrice,
            "symbol": objPayload?.symbol,
            "token": objPayload?.token,

        };

        let resp = await contractDetails(code);

        const contractDetail = resp?.data?.result?.secInfo[0];
        const contractData = {
            sInstrumentName: contractDetail?.sInstrumentName,
            nContrctName: contractDetail?.sSecurityDesc,
            nMarketLot: contractDetail?.nRegularLot,
            sLotUnit: contractDetail?.sQtyUnit !== "" ? contractDetail?.sQtyUnit : 'NA',
            nPrice: contractDetail?.nPriceTick,
            nIssueMaturityDate: contractDetail?.nIssueMaturityDate,
            nUlAsset: contractDetail?.sAssetName,
            nIssuePDate: contractDetail?.nIssuePDate,
            nExpiryDate: contractDetail?.nExpiryDate,
            nPriceFactorQuota: contractDetail?.nPriceQuotFactor,
            nPriceUnitQuota: contractDetail?.nPriceQuotFactor,
            sPriceQuotUnit: contractDetail?.sPriceQuotUnit,
            nMarginTypeIndicator: contractDetail?.nMarginTypeIndicator,
            nMarginMultiplier: contractDetail?.nMarginMultiplier,
            nIntrinsicValue: contractDetail?.nIntrinsicValue,
            nIssueStartDate: contractDetail?.nIssueStartDate,
            nExerciseStartDate: contractDetail?.nExerciseStartDate,
            nExerciseEndDate: contractDetail?.nExerciseEndDate,
            nNoDeliveryStartDate: contractDetail?.nNoDeliveryStartDate,
            nDelEndDate: contractDetail?.nNoDeliveryEndDate,
            nDecimalLocator: contractDetail?.nDecimalLocator,
            NearMonthSymbol: contractDetail?.NearMonthSymbol,
            NearMonthExpiry: contractDetail?.NearMonthExpiry,
            FarMonthSymbol: contractDetail?.FarMonthSymbol,
            FarMonthExpiry: contractDetail?.FarMonthExpiry,
            nInitialLongMargin: contractDetail?.nInitialLongMargin,
            nInitialShortMargin: contractDetail?.nInitialShortMargin,
            nSpecialCashLongMargin: contractDetail?.nSpecialCashLongMargin,
            nSpecialCashShortMargin: contractDetail?.nSpecialCashShortMargin,
            NearMonthId: 'NA',
            FarMonthId: 'NA',
            LotUnit: 'NA',
            MaxOrderQty: 'NA',
            MaxOrderValue: 'NA',
            nOtherLongMargin: contractDetail?.nOtherLongMargin,
            nOtherShortMargin: contractDetail?.nOtherShortMargin,
            nMaxSingleTransactionQty: contractDetail?.nMaxSingleTransactionQty
        };
        // Vaibhav singh: BT-109089 : 25-10-23: Getting highlowclose for calculating support and resistance
        const codeDetails = resp?.data?.result?.highlowclose[0];
        const data = {
            code: codeDetails?.nToken ?? contractDetail?.nToken,
            highlowclose: codeDetails ? codeDetails : {}
        };

        let contractMargin;
        let contractMarginData;
        // Vaibhav Singh: 30-01-24: BT-107248: Causing error due to validation fixed: Start
        if (resp?.data?.result?.pivot?.length > 0) {
            // Vaibhav Singh: 30-01-24: BT-107248: Causing error due to validation fixed: End
            contractMargin = resp?.data?.result?.pivot[0];
            contractMarginData = {
                intialMarginLong: contractMargin['Initial Margin Long'],
                intialMarginShort: contractMargin['Initial Margin Short'],
                totalMarginLong: contractMargin['Total Margin Long'],
                totalMarginShort: contractMargin['Total Margin Short'],
            };
        } else {

        }

        return { status: true, message: BUSINESS_LAYER_RESPONSE?.SUCCESS, data: { contractData, data, contractMarginData } };
    } catch (error) {
        console.log(error);
        return { status: false, message: BUSINESS_LAYER_RESPONSE?.FAILURE, error };


    }
}


async function _getSimpleMovingAverages(objPayload) {
    try {
        //Vaibhav Singh: BT-109089: Scrip Overview : Fixed NSE and BSE data showing same issue
        objPayload['mktSegment'] = EXCHANGE_NAME_API.NSE_EQ_API;
        let respNse = await movingAverage(objPayload);
        const companyMovingMarketNse = respNse?.data?.ResponseObject?.resultset[0];
        objPayload['mktSegment'] = EXCHANGE_NAME_API.BSE_EQ_API;
        let respBse = await movingAverage(objPayload);
        const companyMovingMarketBse = respBse?.data?.ResponseObject?.resultset[0];
        return { status: true, message: BUSINESS_LAYER_RESPONSE?.SUCCESS, data: { movingAverageNSE: companyMovingMarketNse, movingAverageBSE: companyMovingMarketBse } };


    } catch (error) {
        console.log(error);
        return { status: false, message: BUSINESS_LAYER_RESPONSE?.FAILURE, error };
    }
}


async function _getDeliveryQuantity(objPayload) {
    try {
        let resp = await scripOverviewDelivery(objPayload);
        const deliveryQuantity = resp?.data?.ResponseObject?.resultset[0];

        return { status: true, message: BUSINESS_LAYER_RESPONSE?.SUCCESS, data: deliveryQuantity };
    } catch (error) {
        console.log(error);
        return { status: false, message: BUSINESS_LAYER_RESPONSE?.FAILURE, error };

    }
}

async function _getGSMGradeCategory(objPayload) {
    //This function display gsm status yes or no in comapny info tab
    //objPayload contains mkt segment id and token numbers
    try {
        let resp = await gsmGradeCategory(objPayload);
        let GSMCategoryGrade = resp?.data?.result;
        return { status: true, message: BUSINESS_LAYER_RESPONSE?.SUCCESS, data: GSMCategoryGrade };
    } catch (error) {
        return { status: false, message: BUSINESS_LAYER_RESPONSE?.FAILURE, error };
    }

}



export {
    _getFutureTabData,
    _getCompanyExchangeData,
    _getCompanyBackground,
    _getSecurityDetails,
    _getcompanyListingInformation,
    _getCompanyHistory,
    _getBoardOfDirectorsData,
    _getMarketPulse,
    _getContractDetails,
    _getSimpleMovingAverages,
    _getDeliveryQuantity,
    _getGSMGradeCategory,
    _getMarketMovementInfo
};
